module.exports = "publish-page"